import produce from 'immer'
import { Reducer } from 'redux'

import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { SET_HOMEPAGE_ARTICLES } from 'redux/actions/types'
import { CAArticle } from 'interfaces/ca'

interface CAState {
  homepageArticles: CAArticle[]
}

const initialState: CAState = {
  homepageArticles: RESPONSE_PENDING
}

const ca:Reducer<CAState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_HOMEPAGE_ARTICLES:
      return produce(state, draft => {
        draft.homepageArticles = action.homepageArticles
      })
    default:
      return state
  }
}

export default ca
